import {combineReducers} from 'redux';
import appState from './appState';

const appReducer = combineReducers({
  appState,
});

const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};

export default rootReducer;
